import { css } from 'lit';

import { narrow } from '../media.js';

export const customerMembersStyles = css`
  :host {
    display: block;
  }

  h3 {
    margin: var(--space-3) 0 var(--space-1);
    font-size: var(--font-size-sm);
    text-transform: uppercase;
    letter-spacing: var(--tracking-wide);
    color: var(--text-muted);
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-0) 0;
  }

  .actions,
  .inline {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
  }

  .inline {
    margin-top: var(--space-2);
  }

  /* one row where there is room, wrapping on a phone (the form styles make fields full-width) */
  .inline select {
    width: auto;
    flex: none;
  }

  /* On a phone the select gets a line of its own, as wide as the field under it. */
  @media ${narrow} {
    .inline select {
      flex: 1 1 100%;
    }
  }

  .inline input {
    flex: 1 1 var(--inline-field-min-width);
    width: auto;
    min-width: 0;
  }

  .role {
    font-size: var(--font-size-sm);
    color: var(--text-muted);
  }
`;
